
import { defineComponent } from 'vue'
import { IDocument } from '@/modules/workspace/Workspace'
import { AxiosResponse } from 'axios'
import DetailSidebar from '@/modules/workspace/genericComponents/DetailSidebar.vue'
import Message from 'primevue/message'
import WorkspaceCard from '@/modules/workspace/genericComponents/WorkspaceCard.vue'
import mainDescriptor from '@/modules/workspace/WorkspaceDescriptor.json'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { formatDateWithLocale } from '@/helpers/commons/localeHelper'

export default defineComponent({
    components: { DataTable, Column, DetailSidebar, WorkspaceCard, Message },
    emits: ['showMenu', 'toggleDisplayView', 'execute'],
    props: { toggleCardDisplay: { type: Boolean } },
    data() {
        return {
            mainDescriptor,
            loading: false,
            showDetailSidebar: false,
            recentDocumentsList: [] as IDocument[],
            filteredDocuments: [] as IDocument[],
            selectedDocument: {} as IDocument,
            searchWord: '' as string
        }
    },
    created() {
        this.getRecentDocuments()
    },
    methods: {
        getRecentDocuments() {
            this.loading = true
            return this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/recents`)
                .then((response: AxiosResponse<any>) => {
                    this.recentDocumentsList = [...response.data]
                    this.filteredDocuments = [...this.recentDocumentsList]
                })
                .finally(() => (this.loading = false))
        },
        formatDate(date) {
            return formatDateWithLocale(date, { dateStyle: 'short', timeStyle: 'short' })
        },
        executeRecent(document: any) {
            this.$emit('execute', document)
        },
        toggleDisplayView() {
            this.$emit('toggleDisplayView')
        },
        showSidebar(clickedDocument) {
            this.selectedDocument = clickedDocument
            this.showDetailSidebar = true
        },
        searchItems() {
            setTimeout(() => {
                if (!this.searchWord.trim().length) {
                    this.filteredDocuments = [...this.recentDocumentsList] as any[]
                } else {
                    this.filteredDocuments = this.recentDocumentsList.filter((el: any) => {
                        return el.documentType?.toLowerCase().includes(this.searchWord.toLowerCase()) || el.documentName?.toLowerCase().includes(this.searchWord.toLowerCase())
                    })
                }
            }, 250)
        }
    }
})
